export enum FieldDisablementReason {
  NO_PERMISSIONS_TO_EDIT = 'NO_PERMISSIONS_TO_EDIT',
  PAYMENT_INTERVAL_NOT_CHOSEN = 'PAYMENT_INTERVAL_NOT_CHOSEN',
  SINGLE_PAYMENT_INTERVAL_CHOSEN = 'SINGLE_PAYMENT_INTERVAL_CHOSEN',
  VALUE_CALCULATED_AUTOMATICALLY = 'VALUE_CALCULATED_AUTOMATICALLY',
  VALUE_MANAGED_BY_CBS = 'VALUE_MANAGED_BY_CBS',
  FIRST_AMORTIZATION_DATE_INFO = 'FIRST_AMORTIZATION_DATE_INFO'
}
